// extracted by mini-css-extract-plugin
export default {"bgsection":"Backdrop_bgsection__wj1UI","main-structure":"Backdrop_main-structure__0s61P"};